<!-- @format -->

<div *transloco="let t" class="study-period-container">
  @if (period(); as period) {
    <fudis-heading [level]="headingLevel()" [variant]="'md'" class="text-capitalize fudis-mb-none">{{
      period.name | localizedString
    }}</fudis-heading>
    <fudis-body-text [variant]="'md-light'" class="fudis-mb-xs">
      {{ t("TIMELINE.STUDY_PERIOD.SUBHEADING", { valid: period.valid | localDateRange }) }}
    </fudis-body-text>

    <fudis-dl [variant]="'compact'" class="fudis-mb-sm">
      <fudis-dl-item>
        <fudis-dt [contentText]="t('TIMELINE.TIMED_CREDITS')" />
        <fudis-dd [contentText]="period.timedCredits | creditRange: 'TEXT' : true" />
      </fudis-dl-item>
      <fudis-dl-item>
        <fudis-dt [contentText]="t('TIMELINE.ATTAINED_CREDITS')" />
        <fudis-dd [contentText]="period.attainedCredits | decimalNumber" />
      </fudis-dl-item>
    </fudis-dl>

    <fudis-button
      [variant]="'primary'"
      [size]="'medium'"
      [label]="t('TIMELINE.SELECT_COURSE_UNITS.DIALOG_OPEN_BUTTON_EDIT')"
      [attr.aria-label]="`${t('TIMELINE.SELECT_COURSE_UNITS.DIALOG_OPEN_BUTTON_EDIT')} ${period.name | localizedString} ${period.valid | localDateRange}`"
      (handleClick)="openSelectCourseUnitsModal()" />
    <div [class]="'fudis-mt-sm'">
      @if (period.timelineItems.length === 0) {
        <fudis-body-text class="fudis-text-emptystate">
          <i>{{ t("TIMELINE.STUDY_PERIOD.NO_TIMED_UNITS") }}</i>
        </fudis-body-text>
      } @else {
        <ul class="list-unstyled">
          @for (item of period.timelineItems; track item.id) {
            <li class="study-box-list-item">
              @if (isTimelineCourseUnit(item)) {
                <app-timeline-course-unit
                  [courseUnit]="item.courseUnit"
                  [headingLevel]="childHeadingLevel()"
                  [currentPeriod]="period.locator" />
              } @else if (isTimelineCustomCourseUnitAttainment(item)) {
                <app-timeline-custom-course-unit-attainment
                  [customCourseUnitAttainment]="item.customCourseUnitAttainment"
                  [headingLevel]="childHeadingLevel()" />
              } @else if (isTimelineCustomStudyDraft(item)) {
                <app-timeline-custom-study-draft
                  [customStudyDraft]="item.customStudyDraft"
                  [headingLevel]="childHeadingLevel()"
                  [currentPeriod]="period.locator" />
              }
            </li>
          }
        </ul>
      }
    </div>
  }
</div>
